import { Controller } from "@hotwired/stimulus"

/**
 * Contrôleur pour le widget produit qui masque les champs fiscaux quand :
 * - "Same address as delivery" est sélectionné
 * - ET company name dans delivery est vide
 */
export default class extends Controller {
  static targets = ["deliveryCompanyField", "sameAddressRadio", "fiscalFieldContainer", "individualRadio"]

  connect() {
    this.updateVisibility()
  }

  updateVisibility() {
    const isIndividual = this.individualRadioTarget.checked

    if (isIndividual) {
      this.hideFiscalFields()
      return
    }

    const isSameAddress = this.sameAddressRadioTargets.find(radio =>
      radio.checked && radio.value === "1"
    )

    const deliveryCompanyEmpty = this.deliveryCompanyFieldTargets.every(field => {
      const value = field.value || ""
      return value.trim() === ""
    })

    // Masquer si same address ET company vide
    if (isSameAddress && deliveryCompanyEmpty) {
      this.hideFiscalFields()
    } else {
      this.showFiscalFields()
    }
  }

  hideFiscalFields() {
    this.fiscalFieldContainerTargets.forEach(container => {
      container.classList.add('hidden')
      // Désactiver les inputs pour éviter la soumission
      const inputs = container.querySelectorAll('input')
      inputs.forEach(input => input.setAttribute('disabled', 'disabled'))
    })
  }

  showFiscalFields() {
    this.fiscalFieldContainerTargets.forEach(container => {
      container.classList.remove('hidden')
      // Réactiver les inputs
      const inputs = container.querySelectorAll('input')
      inputs.forEach(input => input.removeAttribute('disabled'))
    })
  }
}
